export default __webpack_public_path__ + "img/icon_instagram_active-634402cb486707ce825b8235cc3517fb.png";